import React from 'react';

import Icon, { faPlus } from '~components/icon';

import { TableViewRow } from './types';

interface ComponentProps {
  colCount: number;
  canAdd?: boolean;
  showPagination?: boolean;
  editRow?: TableViewRow | null;
  onAddRow?: () => void;
  onLoadMore?: () => void;
  id?: string;
}

const TableFooter: React.FC<ComponentProps> = ({
  colCount,
  canAdd,
  showPagination,
  editRow,
  onAddRow,
  onLoadMore,
  id = 'table',
}) => {
  return (
    <tfoot>
      {canAdd && !editRow ? (
        <tr>
          <td
            className="p-2 text-center selectable fw-bold"
            colSpan={colCount}
            onClick={onAddRow}
            data-cy={`${id}-table-add-row`}
          >
            <Icon icon={faPlus} /> Add Row
          </td>
        </tr>
      ) : null}
      {showPagination && (
        <tr>
          <td
            className="p-3 text-center selectable fw-bold"
            colSpan={colCount}
            onClick={onLoadMore}
            data-cy={`${id}-table-load-more`}
          >
            LOAD MORE
          </td>
        </tr>
      )}
    </tfoot>
  );
};

export default TableFooter;
